import { type ComponentType } from 'react'
import {
	Box,
	Chip,
	type ChipProps,
	type BoxProps,
} from '@mui/material'
import { amber, green, grey } from '@mui/material/colors'
import { lighten, styled } from '@mui/material/styles'
import { type ActiveFeedStatus, ActiveFeedStatus as IntegrationStatus, INACTIVE_INTEGRATION_STATUS } from '../../../types'

const NORMAL_COLOR_STRENGTH = 900

type StatusChipWrapperProps = ChipProps & {
	status: ActiveFeedStatus | typeof INACTIVE_INTEGRATION_STATUS,
}

export const StatusChipWrapper: ComponentType<StatusChipWrapperProps> = styled( Chip, {
	shouldForwardProp: ( prop ) => ![ 'status' ].includes( prop as string ),
} )<StatusChipWrapperProps>( ( { status, theme } ) => {
	const lightBackgroundStrength = 100
	const darkBackgroundStrength = 600
	let backgroundColor: string
	let color: string

	switch ( status ) {
	case IntegrationStatus.DELAYED:
	case IntegrationStatus.PENDING:
		backgroundColor = amber[ lightBackgroundStrength ]
		color = amber[ NORMAL_COLOR_STRENGTH ]
		break
	case IntegrationStatus.CONNECTED:
		backgroundColor = green[ lightBackgroundStrength ]
		color = green[ NORMAL_COLOR_STRENGTH ]
		break
	case INACTIVE_INTEGRATION_STATUS:
		backgroundColor = grey[ darkBackgroundStrength ]
		color = 'white'
		break
	case IntegrationStatus.AUTH_FAILED:
	case IntegrationStatus.UNRESPONSIVE:
	case IntegrationStatus.ACTION_NEEDED:
		backgroundColor = lighten( theme.palette.error.light, 0.75 )
		color = theme.palette.error.main
		break
	case IntegrationStatus.STATUS_UNSPECIFIED:
	default:
		backgroundColor = grey[ lightBackgroundStrength ]
		color = grey[ NORMAL_COLOR_STRENGTH ]
	}

	return {
		backgroundColor,
		height: theme.spacing( 3.5 ),
		fontWeight: theme.typography.fontWeightMedium,
		color,
	}
} )

type StatusChipIcoProps = BoxProps & {
	status: ActiveFeedStatus | typeof INACTIVE_INTEGRATION_STATUS,
}

export const StatusChipIcon: ComponentType<StatusChipIcoProps> = styled( Box, {
	shouldForwardProp: ( prop ) => ![ 'status' ].includes( prop as string ),
} )<StatusChipIcoProps>( ( { status, theme } ) => {
	let backgroundColor: string

	switch ( status ) {
	case IntegrationStatus.DELAYED:
	case IntegrationStatus.PENDING:
		backgroundColor = amber[ NORMAL_COLOR_STRENGTH ]
		break
	case IntegrationStatus.CONNECTED:
		backgroundColor = green[ NORMAL_COLOR_STRENGTH ]
		break
	case INACTIVE_INTEGRATION_STATUS:
		backgroundColor = 'white'
		break
	case IntegrationStatus.AUTH_FAILED:
	case IntegrationStatus.UNRESPONSIVE:
	case IntegrationStatus.ACTION_NEEDED:
		backgroundColor = theme.palette.error.main
		break
	case IntegrationStatus.STATUS_UNSPECIFIED:
	default:
		backgroundColor = theme.palette.grey[ NORMAL_COLOR_STRENGTH ]
	}

	return {
		backgroundColor,
		width: 8,
		height: 8,
		marginLeft: `${theme.spacing( 1.5 )} !important`,
		borderRadius: '50%',
	}
} )
